export default __webpack_public_path__ + "static/media/googleStoreButton.7e6dfcd0.svg";